import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class CustomerTrustLevelModel extends BaseModel {
  disable_auto_promotion = false;
  trust_level_uuid = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    trust_level_uuid: 'required',
  };

  attributeLabels = {
    trust_level_uuid: i18n.t('Trust Level'),
    disable_auto_promotion: i18n.t('Disable Auto Promotion'),
  };
}
